
import React from 'react';
import FormInputTagsItem from './FormInputTagsItem';
import PageSearch from '../../search/PageSearch';

export default (props) => {
  const inputProps = {
    filterBy: 'name',
    showHidden: true,
  };

  return <FormInputTagsItem {...props} inputComponent={PageSearch} inputProps={inputProps} />;
};
